module.exports = __webpack_public_path__ + "static/media/robot-dev.ad32b40a.png";